import { IconButton, Snackbar, SnackbarCloseReason } from '@mui/material';
import { CloseIcon } from '@upstart/shared-components';
import React from 'react';

interface CloseableSnackbarProps {
  message: string;
  onClose: () => void;
  open: boolean;
}

const CloseableSnackbar = ({
  message,
  onClose,
  open,
}: CloseableSnackbarProps) => {
  const defaultDuration = 6000;

  const handleClose = (
    _event: React.SyntheticEvent<any> | Event | undefined,
    reason: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    onClose();
  };

  const closeIconClick = () => {
    handleClose(undefined, 'escapeKeyDown');
  };

  const action = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={closeIconClick}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={defaultDuration}
      message={message}
      onClose={handleClose}
      action={action}
    />
  );
};

export default CloseableSnackbar;
